'use strict';

(function () {
  angular.module('zp').directive('vendorMap', vendorMapDirective);

  /**ngInject */
  function vendorMapDirective($q, mapConfig, $timeout, mapService) {
    return {
      restrict: 'E',
      templateUrl: 'app/vendors/vendor.map.html',
      link: link,
      scope: {
        vendor: '='
      }
    };

    function link(scope, element, attrs) {

      scope.mapMarkers = [];
      scope.mapOptions = angular.copy(mapConfig.mapOptions);

      var mapLoaded = false;

      /**Activate */
      (function () {
        var currentCarousel = element.parents('.carousel');
        currentCarousel.find('.glyphicon-chevron-left, .glyphicon-chevron-right').bind('click', function () {
          $timeout(function () {
            if (currentCarousel.find('#vendor-map').is(':visible')) {
              if (mapLoaded) {
                return;
              }
              loadMapMarkers().then(setMapOptions).then(function () {
                mapLoaded = true;
              });
            }
          }, 300);
        });
      })();

      function loadMapMarkers() {
        return $q.when(function () {
          scope.mapMarkers.push(scope.vendor.location);
        }());
      }

      function setMapOptions() {
        return $q.when(function () {
          scope.mapOptions.mapCenter = scope.mapMarkers.length ? scope.mapMarkers[0] : null;
          scope.mapOptions.disableDefaultUI = true;
          scope.mapOptions.zoomControl = true;
          scope.mapOptions.streetViewControl = false;
          scope.mapOptions.draggable = true;
          scope.mapOptions.scrollwheel = false;
          scope.mapOptions.disableDoubleClickZoom = true;
          scope.mapOptions.zoom = 13;
          scope.mapOptions.zoomControl = false;
          return true;
        }());
      }
    }
  }
})();